import { Component, OnInit, Input } from '@angular/core';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';

@Component({
  selector: 'app-card-status',
  templateUrl: './card-status.component.html',
  styleUrls: ['./card-status.component.css']
})
export class CardStatusComponent implements OnInit {

  @Input() orderStatus: OrderStatusObject;

  constructor() { }

  ngOnInit() {
  }

}
